/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const RepresentativeContractStatusFilterDefault = `ALL`;

export const RepresentativeContractStatusFilter = zod
  .enum(["EFFECTIVE", "EXPIRED", "ALL"])
  .default(RepresentativeContractStatusFilterDefault);

export type RepresentativeContractStatusFilter = zod.input<
  typeof RepresentativeContractStatusFilter
>;
export type RepresentativeContractStatusFilterOutput = zod.output<
  typeof RepresentativeContractStatusFilter
>;
